import React from 'react'
import DataToken from '../../components/DataToken'
import page from '~utils/page'
import { DISCOVER } from '~shared/Nav'
import Head from '~shared/Head'

// eslint-disable-next-line import/no-unused-modules
export default page(DataToken, {
    highlight: DISCOVER,
    streamrClient: true,
    headComponent: (
        <Head
            mediaDescription="The DATA token"
            // eslint-disable-next-line max-len
            description="The DATA token is an ERC-20 token that is used for payments on the Streamr Marketplace and powers the incentive mechanism on the Streamr platform."
        />
    ),
})
